import jwtDecode from 'jwt-decode'


export const getUser = (jwtKey= localStorage.getItem('access_token')) => {
    try {
        const jwtArr = jwtKey.split(" ") || [];
        const jwt = jwtArr[1]
        const user = jwtDecode(jwt);

        return user;
    }
    catch (ex){
        return null;
    }
};

